module.exports = __webpack_public_path__ + "static/media/seek_15_prev.13246bb5.svg";